import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DipDetection} from './dipdetection';
import 'rxjs/add/operator/toPromise';
import {CustomHttp} from '../../shared';

@Injectable()
export class DipDetectionService {

    private anamolyUrl = '/anomalies/v1';  // URL to web api
    constructor(private router: Router, private http: CustomHttp) {
    }

    getDipDetection(dateFrom: string, dateTo: string, type: string) {
        const url = `${this.anamolyUrl}/dipdetection?dateFrom=${dateFrom}&dateTo=${dateTo}&anomalytype=${type}`;
        return this.http.get(url, {body: ''});
    }


    updateDetection(detection: DipDetection, contentType): Promise<DipDetection> {
        const url = `${this.anamolyUrl}/dipdetection/${contentType}`;
        return this.http.put(url, JSON.stringify(detection));
    }


    updateAllDetection(detection: DipDetection[], status: any, contentType): Promise<DipDetection> {
        const url = `${this.anamolyUrl}/dipdetection/${contentType}/all?requestedStatus=${status}`;
        return this.http.put(url, JSON.stringify(detection));
    }

}



// WEBPACK FOOTER //
// ./src/app/catalogue/dipdetection/dipdetection.service.ts